<div class='configuration-commitments-tab-2-part'>
	This is configuration-commitments tab 2
</div>